import { BetslipEventsEnum } from "src/constants/enums/betslipEvents";
import { listenersMap } from "./listeners";

type ListenerFunc<TValue> = (value: TValue) => void;

const middleware = new EventTarget();

class Communicator {

    public static send<TValue>(type: BetslipEventsEnum, value: TValue) {
        middleware.dispatchEvent(new CustomEvent(type.toString(), { detail: value }));
    }

    public static on<TValue>(type: BetslipEventsEnum, listener: ListenerFunc<TValue>) {
        const eventListener = ((e: CustomEvent<TValue>) => listener(e.detail)) as EventListener;
        middleware.addEventListener(type.toString(), eventListener);

        return () => middleware.removeEventListener(type.toString(), eventListener);
    }

    public static initListeners() {
        Object.entries(listenersMap).forEach(([key, cb]) => {
            Communicator.on(+key, cb as ListenerFunc<any>);
        });
    }
};

export default Communicator;
